import { IoIosReturnLeft } from 'react-icons/io';
import styles from './BackButton.module.css';

/**
 * Card que retorna para a pasta anterior na navegação.
 * `viewMode` controla o layout: 'grid' (padrão, card) ou 'list' (linha).
 */
export default function BackButton({ onClick, viewMode = 'grid' }) {
  const className = viewMode === 'list' ? styles.folderList : styles.folder;

  return (
    <div className={className} onClick={onClick}>
      <IoIosReturnLeft className={styles.icon} />
      <div className={styles.label}>Voltar</div>
    </div>
  );
}